module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia9_thumb-35fa4392eb83479871d02072c440f00a.jpg";